module.exports = __webpack_public_path__ + "img/EWMA-District-Logo-Transparent@1x.fccc5886.webp";